"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
// returns a shuffled copy of input array
const shuffle = ramda_1.curry(function (a) {
    const b = [];
    let i = -1;
    while (++i < ramda_1.length(a)) {
        const x = Math.floor((i + 1) * Math.random());
        b[i] = b[x];
        b[x] = a[i];
    }
    return b;
});
exports.default = shuffle;
